import { render, staticRenderFns } from "./delete-acc-dialog.vue?vue&type=template&id=449f4d6c&"
import script from "./delete-acc-dialog.vue?vue&type=script&lang=tsx&"
export * from "./delete-acc-dialog.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports